export function closeTelegramMiniApp(): void {
  window.Telegram?.WebApp?.close();
}
